// extracted by mini-css-extract-plugin
module.exports = {"background":"tabbed-product-carousel-background_background__xrm3u","backgroundSvg":"tabbed-product-carousel-background_backgroundSvg__t0luL"};